export const color = {
  red: '#ff0033',
  black: '#000',
  white: '#fff',
  grey: '#ccc',
};
